<template>
  <svg :class="phoneClass" :width="width" :height="height" viewBox="0 0 19 19" class="phone-icon" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M4.026 3.5a1.109 1.109 0 0 1 1.108.947c.107.808.305 1.601.591 2.366a1.102 1.102 0 0 1-.247 1.164L4.19 9.263a13.359 13.359 0 0 0 5.534 5.524l1.285-1.283a1.109 1.109 0 0 1 1.172-.248c.765.285 1.56.482 2.365.588a1.107 1.107 0 0 1 .953 1.128v2.418a1.104 1.104 0 0 1-1.2 1.106 15.446 15.446 0 0 1-6.728-2.39 15.177 15.177 0 0 1-4.675-4.667A15.362 15.362 0 0 1 .504 4.705 1.104 1.104 0 0 1 1.607 3.5Z" stroke="currentColor" /></g></svg>
</template>

<script>
export default {
  name: 'Phone',
  props: {
    color: {
      type: String,
      default: 'dark',
    },
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 20,
    },
  },
  computed: {
    phoneClass() {
      return {
        'text-dark': this.color === 'dark',
        'text-light': this.color === 'light',
      };
    },
  },
};

</script>

<style lang="scss" scopped>
  // .phone-icon {
  //   display: block;
  //   width: 20px;
  //   height: 20px;
  // }
</style>
